import React from 'react'
import moment from 'moment'

const NewsItemDate = ({postItem, postItemHome}) => postItem && postItem._source && postItem._source.post_date &&
	<p className={`news-list-item-date${postItemHome ? " news-list-home-item-date" : ""}`}>
		Publié le {moment(postItem._source.post_date).format("DD MMMM YYYY")}
	</p>

export default NewsItemDate